import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import RESOURCE_DROP_OFF_MODIFIERS from "../data/resource-drop-off-modifiers/AllResourceDropOffModifiers";
import changeCivilization from "./actions/CivilizationChnagedAction";
import {
    ALL_CIVILIZATIONS_RESOURCE_DROP_OFF_MODIFIERS,
    RESOURCE_DROP_OFF_MODIFIERS_DEFAULT
} from "../data/civilization-modifiers/AllCivilizationSpecificModifiers";
import {RootState} from "../store";
import ResourceDropOffModifier from "../model/ResourceDropOffModifier";

export interface ResourceDropOffModifiersState {
    [key: string]: boolean
}

export interface UnselectSelectResourceDropOffPayload {
    unselect: string[],
    select: string[]
}

const initialState: ResourceDropOffModifiersState = Object.values(RESOURCE_DROP_OFF_MODIFIERS)
    .reduce((state: ResourceDropOffModifiersState, modifier) => {
        state[modifier.id] = false;
        return state;
    }, {});

export const resourceDropOffModifiers = createSlice({
    name: 'resourceDropOffModifiers',
    initialState: initialState,
    reducers: {
        toggleResourceDropOffModifier: (state, action: PayloadAction<string>) => {
            let id: string = action.payload;
            state[id] = !state[id];
        },
        unselectSelectResourceDropOff: (state, action: PayloadAction<UnselectSelectResourceDropOffPayload>) => {
            action.payload.unselect.forEach(id => state[id] = false);
            action.payload.select.forEach(id => state[id] = true);
        }
    },
    extraReducers: builder => {
        builder.addCase(changeCivilization, (state, action) => {
            ALL_CIVILIZATIONS_RESOURCE_DROP_OFF_MODIFIERS.forEach(id => state[id] = false);
            (RESOURCE_DROP_OFF_MODIFIERS_DEFAULT[action.payload] || []).forEach(id => state[id] = true)
        })
    }
});

export let selectActiveResourceDropOffModifiers = (state: RootState): ResourceDropOffModifier[] => {
    return Object.keys(state.resourceDropOffModifiers)
        .filter(id => state.resourceDropOffModifiers[id])
        .map(id => RESOURCE_DROP_OFF_MODIFIERS[id]);
}

export const {toggleResourceDropOffModifier, unselectSelectResourceDropOff} = resourceDropOffModifiers.actions;
export default resourceDropOffModifiers.reducer;